import React from 'react';

const BlogSkeleton: React.FC = () => {
  return (
    <div className="mt-2">
      {[1, 2, 3, 4, 5].map((item) => (
        <div 
          key={item}
          className="animate-pulse bg-gray-200 flex rounded-lg p-2 mb-1"
        >
          <div className="h-6 w-6 bg-gray-300 rounded-full"></div>
          <div className="w-full ml-2">
            <div className="h-4 bg-gray-300 rounded w-3/4 mb-2"></div>
            <div className="h-3 bg-gray-300 rounded w-full"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BlogSkeleton;
